import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  alerts: [],
  fetching: false,
  posting: false,
  response: '',
  alertsCount: 0,
  rowsPerPage: 20,
  page: 1,
  filterCaseTypes: [],
  filterSubCaseTypes: [],
  filterFirms: [],
  filterValidFrom: '',
  filterValidTo: '',
  filterSearch: '',
  applicableInternalAlerts: [],
}

const internalAlertsActions = {
  getApplicableInternalAlerts: (state, action) => {
    state.fetching = true
  },
  failedGetApplicableInternalAlerts: (state, action) => {
    state.fetching = false
  },
  receiveApplicableInternalAlerts: (state, action) => {
    state.fetching = false
    state.applicableInternalAlerts = action.payload.body
  },
  getInternalAlerts: (state, action) => {
    state.fetching = true
  },
  receiveInternalAlerts: (state, action) => {
    state.fetching = false
    state.alerts = action.payload.body.alerts
    state.alertsCount = action.payload.body.alertsCount
  },
  failedGetInternalAlerts: (state, action) => {
    state.fetching = false
    state.response = action.payload.response.body.message
  },
  changeInternalAlertsSettings: (state, action) => {
    const { key, value } = action.payload
    if (key === 'clearFilters') {
      return defaultState
    }
    state[key] = value
  },
  resetInternalAlertsState: () => {
    return defaultState
  },
}

const internalAlerts = createSlice({
  name: 'internalAlerts',
  initialState: defaultState,
  reducers: internalAlertsActions,
})

export const {
  getApplicableInternalAlerts,
  failedGetApplicableInternalAlerts,
  receiveApplicableInternalAlerts,
  getInternalAlerts,
  receiveInternalAlerts,
  failedGetInternalAlerts,
  changeInternalAlertsSettings,
  resetInternalAlertsState,
} = internalAlerts.actions;
export default internalAlerts.reducer
